import type { Application, StoreYard } from "../types";

/** Ship-to block for PO PDF — beneficiary site from ho_application fields. */
export function formatBeneficiaryShipToForPrint(app: Application): string {
  const lines: string[] = [];
  const name = app.mobile.beneficiaryName.trim();
  if (name) lines.push(name);
  const plot = (app.sitePlot ?? "").trim();
  if (plot) lines.push(plot);
  const lat = (app.siteLatitude ?? "").trim();
  const lng = (app.siteLongitude ?? "").trim();
  if (lat || lng) {
    lines.push(`Latitude: ${lat || "—"}, Longitude: ${lng || "—"}`);
  }
  const state = (app.siteState ?? "").trim() || "Telangana";
  const geo = [app.village, app.mandal, app.district, state].map((x) => String(x ?? "").trim()).filter(Boolean);
  if (geo.length) lines.push(geo.join(", "));
  return lines.join("\n").trim() || "—";
}

/** Ship-to block for PO PDF — store master address. */
export function formatStoreShipToForPrint(store: StoreYard): string {
  const name = store.name.trim();
  const addr = (store.address ?? "").trim();
  if (name && addr) return `${name}\n${addr}`;
  return name || addr || "—";
}
